/// <amd-module name="Dashboards/RateLimiter/hasHeaderThrottlingMarkings" />
import { RateLimitHttpHeaderConstants } from "./Constants";

/** Responsible for policy of deciding if a header has problematic header markings for throttling. */
export function hasHeaderThrottlingMarkings(getProperty: (propertyName: string) => string | null): boolean {
    // Note: This flag is only provided by AT for traffic exceeding 2/3 of RU threshold.
    // Currently this is a convenient pattern, which isn't contractually guaranteed. We are asking for an explicit contract of either:
    // Client evaluatable proportion of capacity, or an explicit flag from AT saying to "back-off"
    return getProperty(RateLimitHttpHeaderConstants.VssRateLimitRemaining) !== null;
}
